import { FormEvent, useState } from "react";
import { Link } from "react-router-dom";
import { useForgotPassword } from "./useForgotPassword";
import { AuthShell } from "./AuthShell";
import { Field } from "../ui/Field";
import { TextInput } from "../ui/TextInput";
import { Button } from "../ui/Button";
import { Banner } from "../ui/Banner";
import { useTranslation } from "../i18n";

export function ForgotPasswordPage() {
  const { t } = useTranslation("auth");
  const [email, setEmail] = useState("");
  const forgot = useForgotPassword();

  function onSubmit(e: FormEvent): void {
    e.preventDefault();
    forgot.mutate({ email });
  }

  return (
    <AuthShell>
      <h1 className="mb-6 text-2xl font-semibold text-slate-100">{t("forgotTitle")}</h1>

      {/* Success is intentionally the same for any address (no user enumeration). */}
      {forgot.isSuccess ? (
        <Banner kind="success" className="mb-4">
          {t("forgotSent")}
        </Banner>
      ) : (
        <>
          <p className="mb-4 text-sm text-slate-400">{t("forgotIntro")}</p>
          <form onSubmit={onSubmit} className="space-y-4" noValidate>
            <Field label={t("email")}>
              {({ id, ...ariaProps }) => (
                <TextInput
                  id={id}
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  {...ariaProps}
                />
              )}
            </Field>
            <Button
              type="submit"
              variant="primary"
              className="w-full"
              disabled={forgot.isPending}
            >
              {forgot.isPending ? t("forgotSending") : t("forgotSubmit")}
            </Button>
          </form>
        </>
      )}

      <p className="mt-6 text-sm text-slate-400">
        <Link to="/sign-in" className="text-arch-400 hover:underline">
          {t("backToSignIn")}
        </Link>
      </p>
    </AuthShell>
  );
}
